module.exports = __webpack_public_path__ + "static/media/eye.461e0a26.svg";